import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";

const TermsOfUse: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "Terms of Use",
      path: "/terms-of-use",
    },
  ];

  return (
    <div className="flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Terms of Use Content */}
        <div className="w-full pt-[15px] pb-[86px] bg-white">
          <div className="px-5 max-w-[1710px] mx-auto mb-10">
            <h2 className="text-3xl md:text-[30px] font-semibold text-[#202020] mb-6 mt-[30px]">
              Terms of Use
            </h2>

            <div className="space-y-[30px] text-[#101010] font-normal text-[16px] leading-[25px]">
              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Overview
                </h2>
                <p>
                  This website is operated by PPE.us. Throughout the site, the
                  terms "we", "us" and "our" refer to PPE.us. PPE.us offers this
                  website, including all information, tools and services
                  available from this site to you, the user, conditioned upon
                  your acceptance of all terms, conditions, policies and notices
                  stated here.
                </p>
                <p className="mt-[18px]">
                  By visiting our site and/or purchasing something from us, you
                  agree to be bound by the following terms and conditions
                  ("Terms of Use", "Terms"), including those additional terms
                  and conditions and policies referenced herein and/or available
                  by hyperlink. These Terms of Use apply to all users of the
                  site, including without limitation users who are browsers,
                  vendors, customers, merchants, and/ or contributors of
                  content.
                </p>
                <p className="mt-[18px]">
                  Please read these Terms of Use carefully before accessing or
                  using our website. By accessing or using any part of the site,
                  you agree to be bound by these Terms of Use. If you do not
                  agree to all the terms and conditions of this agreement, then
                  you may not access the website or use any services. If these
                  Terms of Use are considered an offer, acceptance is expressly
                  limited to these Terms of Use.
                </p>
                <p className="mt-[18px]">
                  Any new features or tools which are added to the current store
                  shall also be subject to the Terms of Use. You can review the
                  most current version of the Terms of Use at any time on this
                  page. We reserve the right to update, change or replace any
                  part of these Terms of Use by posting updates and/or changes
                  to our website. It is your responsibility to check this page
                  periodically for changes. Your continued use of or access to
                  the website following the posting of any changes constitutes
                  acceptance of those changes.
                </p>
                <p className="mt-[18px]">
                  These Terms of Use only relate to your use of this website and
                  do not contain the terms of sale for services and products
                  offered for sale on this website. Our Terms of Sale for your
                  purchase of such services and products on this website can be
                  found at Terms of Sale.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 1 - Online Store Terms
                </h2>
                <p>
                  By agreeing to these Terms of Use, you represent that you are
                  at least the age of majority in your state or province of
                  residence, or that you are the age of majority in your state
                  or province of residence and you have given us your consent to
                  allow any of your minor dependents to use this site.
                </p>
                <p className="mt-[18px]">
                  You may not use our products for any illegal or unauthorized
                  purpose nor may you, in the use of the website, violate any
                  laws in your jurisdiction (including but not limited to
                  copyright laws).
                </p>
                <p className="mt-[18px]">
                  You must not transmit any worms or viruses or any code of a
                  destructive nature.
                </p>
                <p className="mt-[18px]">
                  A breach or violation of any of the Terms will result in an
                  immediate termination of your access to the website and/or our
                  products and services.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 2 - General Conditions
                </h2>
                <p>
                  We reserve the right to refuse service to anyone for any
                  reason at any time.
                </p>
                <p className="mt-[18px]">
                  You understand that your content (not including credit card
                  information), may be transferred unencrypted and involve (a)
                  transmissions over various networks; and (b) changes to
                  conform and adapt to technical requirements of connecting
                  networks or devices. Credit card information is always
                  encrypted during transfer over networks.
                </p>
                <p className="mt-[18px]">
                  You agree not to reproduce, duplicate, copy, sell, resell or
                  exploit any portion of the website, use of the website, or
                  access to the website or any contact on the website through
                  which our products or services are provided, without express
                  written permission by us.
                </p>
                <p className="mt-[18px]">
                  The headings used in this agreement are included for
                  convenience only and will not limit or otherwise affect these
                  Terms.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 3 - Accuracy, Completeness And Timeliness Of
                  Information
                </h2>
                <p>
                  We are not responsible if information made available on this
                  site is not accurate, complete or current. The material on
                  this site is provided for general information only and should
                  not be relied upon or used as the sole basis for making
                  decisions without consulting primary, more accurate, more
                  complete or more timely sources of information. Any reliance
                  on the material on this site is at your own risk.
                </p>
                <p className="mt-[18px]">
                  This site may contain certain historical information.
                  Historical information, necessarily, is not current and is
                  provided for your reference only. We reserve the right to
                  modify the contents of this site at any time, but we have no
                  obligation to update any information on our site. You agree
                  that it is your responsibility to monitor changes to our site.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 4 - Modifications To The Website
                </h2>
                <p>
                  We reserve the right at any time to modify or discontinue the
                  website (or any part or content thereof) without notice at any
                  time.
                </p>
                <p className="mt-[18px]">
                  We shall not be liable to you or to any third-party for any
                  modification, suspension or discontinuance of the website.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 5 - Products Or Services (if applicable)
                </h2>
                <p>
                  Certain products or services may be available exclusively
                  online through the website. These products or services may
                  have limited quantities.
                </p>
                <p className="mt-[18px]">
                  We have made every effort to display as accurately as possible
                  the colors and images of our products that appear at the
                  store. We cannot guarantee that your computer monitor's
                  display of any color will be accurate.
                </p>
                <p className="mt-[18px]">
                  We reserve the right, but are not obligated, to limit the
                  sales of our products or services to any person, geographic
                  region or jurisdiction. We may exercise this right on a
                  case-by-case basis. We reserve the right to limit the
                  quantities of any products or services that we offer. All
                  descriptions of products or product pricing are subject to
                  change at anytime without notice, at the sole discretion of
                  us. We reserve the right to discontinue any product at any
                  time. Any offer made on this site to sell any product or
                  service is void if the sale of such product or service is
                  prohibited in any applicable jurisdiction.
                </p>
                <p className="mt-[18px]">
                  Samples: PPE.us sends samples to qualified business clients
                  and organizations. If you'd like to expedite your sample,
                  please provide us with your shipping account number. We also
                  reserve the right to refuse samples to anyone at our
                  discretion.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 6 - Accuracy Of Billing And Account Information
                </h2>
                <p>
                  You agree to provide current, complete and accurate purchase
                  and account information for all purchases made at our store.
                  You agree to promptly update your account and other
                  information, including your email address and credit card
                  numbers and expiration dates, so that we can complete your
                  transactions and contact you as needed.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 7 - Optional Tools
                </h2>
                <p>
                  We may provide you with access to third-party tools over which
                  we neither monitor nor have any control nor input.
                </p>
                <p className="mt-[18px]">
                  You acknowledge and agree that we provide access to such tools
                  "as is" and "as available" without any warranties,
                  representations or conditions of any kind and without any
                  endorsement. We shall have no liability whatsoever arising
                  from or relating to your use of optional third-party tools.
                </p>
                <p className="mt-[18px]">
                  Any use by you of optional tools offered through the site is
                  entirely at your own risk and discretion and you should ensure
                  that you are familiar with and approve of the terms on which
                  tools are provided by the relevant third-party provider(s).
                </p>
                <p className="mt-[18px]">
                  We may also, in the future, offer new services and/or features
                  through the website (including, the release of new tools and
                  resources). Such new features and/or services shall also be
                  subject to these Terms of Use.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 8 - Third-Party Links
                </h2>
                <p>
                  Certain content, products and services available via our
                  website may include materials from third-parties.
                </p>
                <p className="mt-[18px]">
                  Third-party links on this site may direct you to third-party
                  websites that are not affiliated with us. We are not
                  responsible for examining or evaluating the content or
                  accuracy and we do not warrant and will not have any liability
                  or responsibility for any third-party materials or websites,
                  or for any other materials, products, or services of
                  third-parties.
                </p>
                <p className="mt-[18px]">
                  We are not liable for any harm or damages related to the
                  purchase or use of goods, services, resources, content, or any
                  other transactions made in connection with any third-party
                  websites. Please review carefully the third-party's policies
                  and practices and make sure you understand them before you
                  engage in any transaction. Complaints, claims, concerns, or
                  questions regarding third-party products should be directed to
                  the third-party.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 9 - User Comments, Feedback And Other Submissions
                </h2>
                <p>
                  If, at our request, you send certain specific submissions (for
                  example contest entries) or without a request from us you send
                  creative ideas, suggestions, proposals, plans, or other
                  materials, whether online, by email, by postal mail, or
                  otherwise (collectively, 'comments'), you agree that we may,
                  at any time, without restriction, edit, copy, publish,
                  distribute, translate and otherwise use in any medium any
                  comments that you forward to us. We are and shall be under no
                  obligation (1) to maintain any comments in confidence; (2) to
                  pay compensation for any comments; or (3) to respond to any
                  comments.
                </p>
                <p className="mt-[18px]">
                  We may, but have no obligation to, monitor, edit or remove
                  content that we determine in our sole discretion are unlawful,
                  offensive, threatening, libelous, defamatory, pornographic,
                  obscene or otherwise objectionable or violates any party's
                  intellectual property or these Terms of Use.
                </p>
                <p className="mt-[18px]">
                  You agree that your comments will not violate any right of any
                  third-party, including copyright, trademark, privacy,
                  personality or other personal or proprietary right. You
                  further agree that your comments will not contain libelous or
                  otherwise unlawful, abusive or obscene material, or contain
                  any computer virus or other malware that could in any way
                  affect the operation of the website or any related website.
                  You may not use a false e-mail address, pretend to be someone
                  other than yourself, or otherwise mislead us or third-parties
                  as to the origin of any comments. You are solely responsible
                  for any comments you make and their accuracy. We take no
                  responsibility and assume no liability for any comments posted
                  by you or any third-party.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 10 - Personal Information
                </h2>
                <p>
                  Your submission of personal information through the store is
                  governed by our Privacy Policy.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 11 - Errors, Inaccuracies And Omissions
                </h2>
                <p>
                  Occasionally there may be information on our site that
                  contains typographical errors, inaccuracies or omissions that
                  may relate to product descriptions, pricing, promotions,
                  offers, product shipping charges, transit times and
                  availability. We reserve the right to correct any errors,
                  inaccuracies or omissions, and to change or update information
                  or cancel orders if any information on the website or on any
                  related website is inaccurate at any time without prior notice
                  (including after you have submitted your order).
                </p>
                <p className="mt-[18px]">
                  We undertake no obligation to update, amend or clarify
                  information on the website or on any related website,
                  including without limitation, pricing information, except as
                  required by law. No specified update or refresh date applied
                  to the website or on any related website, should be taken to
                  indicate that all information on the website or on any related
                  website has been modified or updated.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 12 - Prohibited Uses
                </h2>
                <p>
                  In addition to other prohibitions as set forth in these Terms
                  of Use, you are prohibited from using the site or its content:
                  (a) for any unlawful purpose; (b) to solicit others to perform
                  or participate in any unlawful acts; (c) to violate any
                  international, federal, provincial or state regulations,
                  rules, laws, or local ordinances; (d) to infringe upon or
                  violate our intellectual property rights or the intellectual
                  property rights of others; (e) to harass, abuse, insult, harm,
                  defame, slander, disparage, intimidate, or discriminate based
                  on gender, sexual orientation, religion, ethnicity, race, age,
                  national origin, or disability; (f) to submit false or
                  misleading information; (g) to upload or transmit viruses or
                  any other type of malicious code that will or may be used in
                  any way that will affect the functionality or operation of the
                  website or of any related website, other websites, or the
                  Internet; (h) to collect or track the personal information of
                  others; (i) to spam, phish, pharm, pretext, spider, crawl, or
                  scrape; (j) for any obscene or immoral purpose; or (k) to
                  interfere with or circumvent the security features of the
                  website or any related website, other websites, or the
                  Internet. We reserve the right to terminate your use of the
                  website or any related website for violating any of the
                  prohibited uses.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 13 - Disclaimer Of Warranties; Limitation Of Liability
                </h2>
                <p>
                  We do not guarantee, represent or warrant that your use of our
                  website will be uninterrupted, timely, secure or error-free.
                </p>
                <p className="mt-[18px]">
                  We do not warrant that the results that may be obtained from
                  the use of the website will be accurate or reliable.
                </p>
                <p className="mt-[18px]">
                  You agree that from time to time we may remove the website for
                  indefinite periods of time or cancel the website at any time,
                  without notice to you.
                </p>
                <p className="mt-[18px]">
                  You expressly agree that your use of, or inability to use, the
                  website is at your sole risk. The website is provided 'as is'
                  and 'as available' for your use, without any representation,
                  warranties or conditions of any kind, either express or
                  implied, including any implied warranties or conditions of
                  merchantability, merchantable quality, fitness for a
                  particular purpose, durability, or non-infringement.
                </p>
                <p className="mt-[18px]">
                  In no case shall PPE.us, our directors, officers, employees,
                  affiliates, agents, contractors, interns, suppliers, service
                  providers or licensors be liable for any injury, loss, claim,
                  or any direct, indirect, incidental, punitive, special, or
                  consequential damages of any kind, including, without
                  limitation lost profits, lost revenue, lost savings, loss of
                  data, replacement costs, or any similar damages, whether based
                  in contract, tort (including negligence), strict liability or
                  otherwise, arising from or related to your use of the website,
                  including, but not limited to, any errors or omissions in any
                  content, or any loss or damage of any kind incurred as a
                  result of the use of the website or any content posted,
                  transmitted, or otherwise made available via the website, even
                  if advised of their possibility. Because some states or
                  jurisdictions do not allow the exclusion or the limitation of
                  liability for consequential or incidental damages, in such
                  states or jurisdictions, our liability shall be limited to the
                  extent permitted by law.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 14 - Indemnification
                </h2>
                <p>
                  You agree to indemnify, defend and hold harmless PPE.us and
                  our parent, subsidiaries, affiliates, partners, officers,
                  directors, agents, contractors, licensors, service providers,
                  subcontractors, suppliers, interns and employees, harmless
                  from any claim or demand, including reasonable attorney's
                  fees, made by any third-party due to or arising out of your
                  breach of these Terms of Use or the documents they incorporate
                  by reference, or your violation of any law or the rights of a
                  third-party.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 15 - Severability
                </h2>
                <p>
                  In the event that any provision of these Terms of Use is
                  determined to be unlawful, void or unenforceable, such
                  provision shall nonetheless be enforceable to the fullest
                  extent permitted by applicable law, and the unenforceable
                  portion shall be deemed to be severed from these Terms of Use.
                  Such determination shall not affect the validity and
                  enforceability of any other remaining provisions.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 16 - Termination
                </h2>
                <p>
                  The obligations and liabilities of the parties incurred prior
                  to the termination date shall survive the termination of this
                  agreement for all purposes.
                </p>
                <p className="mt-[18px]">
                  These Terms of Use are effective unless and until terminated
                  by us.
                </p>
                <p className="mt-[18px]">
                  If in our sole judgment you fail, or we suspect that you have
                  failed, to comply with any term or provision of these Terms of
                  Use, we also may terminate this agreement at any time without
                  notice and you will remain liable for all amounts due up to
                  and including the date of termination; and/or accordingly may
                  deny you access to our website (or any part thereof).
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 17 - Entire Agreement
                </h2>
                <p>
                  The failure of us to exercise or enforce any right or
                  provision of these Terms of Use shall not constitute a waiver
                  of such right or provision.
                </p>
                <p className="mt-[18px]">
                  These Terms of Use, together with PPE.us Terms of Sale and
                  Privacy Policy, and any policies or operating rules posted by
                  us on this site or in respect to the website, constitutes the
                  entire agreement and understanding between you and us and
                  govern your use of the website, superseding any prior or
                  contemporaneous agreements, communications and proposals,
                  whether oral or written, between you and us (including, but
                  not limited to, any prior versions of the Terms of Use).
                </p>
                <p className="mt-[18px]">
                  Any ambiguities in the interpretation of these Terms of Use
                  shall not be construed against the drafting party.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 18 - Governing Law
                </h2>
                <p>
                  These Terms of Use shall be governed by and construed in
                  accordance with the laws of Illinois, excluding its conflict
                  of laws provisions.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 19 - Changes To Terms Of Service
                </h2>
                <p>
                  You can review the most current version of the Terms of Use at
                  any time at this web page.
                </p>
                <p className="mt-[18px]">
                  We reserve the right, at our sole discretion, to update,
                  change or replace any part of these Terms of Use by posting
                  updates and changes to our website. It is your responsibility
                  to check our website periodically for changes. Your continued
                  use of or access to our website following the posting of any
                  changes to these Terms of Use constitutes acceptance of those
                  changes.
                </p>
              </div>

              <div>
                <h2 className="text-[20px] font-semibold text-[#202020] mb-3">
                  Section 20 - Contact Information
                </h2>
                <p>
                  Questions about the Terms of Use should be sent to us at 
                  <a href="mailto:hello@ppe.us" className="text-[#007aff] hover:underline"> hello@ppe.us</a>.
                </p>
                <p className="mt-[18px]">Effective as of August 19, 2021.</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsOfUse;
